<template>
  <div>
    <div>
      <div class="bordered-tabs d-flex justify-content-between">
        <strong class="h5 font-weight-black">
          {{ locale.list }} {{ locale.debtorEmployees.tabTitle }}
        </strong>
        <div>
          <naj-button
            :disabled="isViewMode || (auditConfirmations[`flag_${mainRequestAuditFlag.debtorEmployeesConfirmation}`] && isNotCompleted)"
            color="primary"
            @click="addNewHandler"
          >
            <v-icon
              left
              v-text="`mdi-plus`"
            ></v-icon>
            {{ local.common.add }}
          </naj-button>
          <!-- <naj-button
          color="primary"
          @click="importDataHandler"
        >
          {{ locale.importData }}
        </naj-button> -->
        </div>
      </div>
      <div>
        <p>
          {{ locale.debtorEmployees.totalCount }}
          <strong class="totalCount">
            {{ pagination.totalCount ? pagination.totalCount : 0 }}
          </strong>
          {{ locale.debtorEmployees.totalSum }}
          <strong class="totalCount">
            {{ totalSum ? totalSum : 0 }}
          </strong>
        </p>
      </div>
      <div>
        <slot />
      </div>
      <div>
        <v-row>
          <v-col>
            <naj-item-table
              :data-items="debtorEmployees.list"
              :headers="headers"
              :pagination="pagination"
              :loading="loading"
              :items-per-page="pagination.pageSize"
              :server-items-length="pagination.totalCount"
              :enable-expand="false"
              @update:page="onPageChange"
            >
              <template
                slot="actionEdit"
                slot-scope="{item}"
              >
                <naj-button
                  :disabled="isViewMode || (auditConfirmations[`flag_${mainRequestAuditFlag.debtorEmployeesConfirmation}`] && isNotCompleted)"
                  outlined
                  @click="showUpdateModal(item)"
                >
                  {{ local.common.update }}
                </naj-button>
              </template>
              <template
                slot="actionDelete"
                slot-scope="{item}"
              >
                <naj-button
                  :disabled="isViewMode || (auditConfirmations[`flag_${mainRequestAuditFlag.partnersConfirmation}`] && isNotCompleted)"
                  type="button"
                  color="error"
                  outlined
                  @click="showPopupRemove(item)"
                >
                  {{
                    local.common.remove
                  }}
                </naj-button>
              </template>
            </naj-item-table>
          </v-col>
        </v-row>
      </div>
    </div>
    <naj-modal
      ref="addModal"
      :title="isEditMode? `${local.common.update} ${locale.debtorEmployees.debtorEmployee}` : `${local.common.add} ${locale.debtorEmployees.debtorEmployee}`"
      :width="1200"
      show-footer-close-button
      @onClose="onCloseModal"
    >
      <v-form ref="addForm">
        <debtor-employee-form
          :form-model="formModel"
          :loading="loading"
        ></debtor-employee-form>
      </v-form>
      <template slot="actions">
        <naj-button
          :loading="loading"
          @click="submit"
        >
          {{ isEditMode? local.common.update :local.common.add }}
        </naj-button>
      </template>
    </naj-modal>
    <naj-confirmation
      :show-modal="showRemovePopup"
      color="error"
      :title="local.common.removeConfirmation"
      :message="local.common.removeConfirmationMessage"
      :ok-btn-label="local.common.remove"
      @ok="removeDebtorEmployee"
      @cancel="showRemovePopup = false"
    ></naj-confirmation>
  </div>
</template>

<script>
import DebtorEmployeeForm from './debtor-employee-form.vue';
import { createNamespacedHelpers } from 'vuex';
const { mapActions, mapGetters, mapState } = createNamespacedHelpers('BankruptcyModule');
import { partyTypeEnum, mainRequestAuditFlag, requestStatusEnum } from '@/modules/bankruptcy/helpers/enum';

export default {
  components: { DebtorEmployeeForm },
  props: {
    requestObjectKey: {
      type: String,
      required: true,
      default: '',
    },
  },
  data() {
    return {
      partyTypeEnum,
      locale: this.local.bankruptcy.requestDetails,
      debtorEmployees: { list: [] },
      totalSum: 0,
      headers: [
        {
          value: 'index',
          text: this.local.bankruptcy.requestDetails.sequence,
        },
        {
          value: 'employeeName',
          text: this.local.bankruptcy.requestDetails.debtorEmployees.theEmployee,
        },
        {
          value: 'identityType',
          text: this.local.bankruptcy.requestDetails.debtorEmployees.identityType,
        },
        {
          value: 'identityNumber',
          text: this.local.bankruptcy.requestDetails.debtorEmployees.identityNumber,
        },
        {
          value: 'nationalityName',
          text: this.local.bankruptcy.requestDetails.debtorEmployees.nationality,
        },
        {
          value: 'mobile',
          text: this.local.bankruptcy.requestDetails.debtorEmployees.mobile,
        },
        {
          value: 'email',
          text: this.local.bankruptcy.requestDetails.debtorEmployees.email,
        },
        {
          value: 'salaryPerMonth',
          text: this.local.bankruptcy.requestDetails.debtorEmployees.salaryPerMonth,
        },
        {
          value: 'currency',
          text: this.local.bankruptcy.requestDetails.debtorEmployees.currency,
        },
        {
          value: 'duesValue',
          text: this.local.bankruptcy.requestDetails.debtorEmployees.duesValue,
        },
        {
          value: 'actionEdit',
          class: 'action-item justify-content-center',
          isCustomTemplate: true,
        },
        {
          value: 'actionDelete',
          class: 'action-item justify-content-center',
          isCustomTemplate: true,
        },
      ],
      pagination: {
        pageSize: 10,
        pageIndex: 0,
        totalCount: 0,
        totalPages: 0,
        hasPreviousPage: false,
        hasNextPage: false,
      },
      formModel: {},
      loading: false,
      isEditMode: false,
      mainRequestAuditFlag,
      requestStatusEnum,
      showRemovePopup: false,
      selectedItem: {},
    };
  },
  computed: {
    ...mapGetters([
      'isViewMode',
      'isNewMode',
      'isNotCompleted',
    ]),
    ...mapState({ auditConfirmations: state => state.auditConfirmations }),
  },
  mounted() {
    this.pagination.pageIndex = 0;
    this.loadData();
  },
  methods: {
    ...mapActions(['submitAddNewDebtorEmployee', 'getDebtorEmployeesByRequestObjectKey', 'updateDebtorEmployee', 'getDebtorEmployee', 'deleteDebtorEmployee']),
    addNewHandler() {
      this.isEditMode = false;
      this.$refs.addModal.show();
    },
    importDataHandler() { },
    loadData() {
      this.loading = true;
      this.totalSum = 0;
      this.getDebtorEmployeesByRequestObjectKey({
        requestObjectKey: this.requestObjectKey,
        ...this.pagination,
      })
        .then(({ data }) => {
          this.loading = false;
          this.debtorEmployees = { ...data };
          this.debtorEmployees.list.forEach((element, index) => {
            element.index = index + 1 + (this.pagination.pageSize * this.pagination.pageIndex);
          });

          if (this.debtorEmployees.list.length)
            this.totalSum = this.debtorEmployees.list[0].totalSum;

          this.pagination = {
            pageIndex: data.pageIndex,
            pageSize: data.pageSize,
            totalCount: data.totalCount,
            totalPages: data.totalPages,
            hasPreviousPage: data.hasPreviousPage,
            hasNextPage: data.hasNextPage,
          };
        })
        .finally(() => {
          this.loading = false;
        });

    },
    onPageChange(pageIndex) {
      this.pagination.pageIndex = pageIndex - 1;
      this.loadData();
    },
    showPopupRemove(item) {
      this.showRemovePopup = true;
      this.selectedItem = item;
    },
    removeDebtorEmployee() {
      const params = {
        requestObjectKey: this.requestObjectKey,
        objectKey: this.selectedItem.objectKey,
      };
      this.loading = true;
      this.deleteDebtorEmployee(params)
        .then(() => {
          this.loadData();
          this.toaster.success(this.local.bankruptcy.common.removeSuccessfully);
        })
        .finally(() => {
          this.loading = false;
          this.showRemovePopup = false;
        });
    },
    submit() {
      if (this.$refs.addForm)
        this.$refs.addForm.$validator.validateAll().then((valid) => {
          if (valid) {
            this.loading = true;
            this.formModel.requestObjectKey = this.requestObjectKey;
            const method = this.formModel.objectKey ? 'updateDebtorEmployee' : 'submitAddNewDebtorEmployee';
            this[method]({
              requestObjectKey: this.requestObjectKey,
              ...this.formModel,
            })
              .then(() => {
                const message = this.formModel.objectKey ? 'updateSuccessfully' : 'addedSuccessfully';
                this.$refs.addModal.close();
                this.loadData();
                this.toaster.success(this.local.bankruptcy.common[message]);
              })
              .finally(() => { this.loading = false; });
          }
        });
    },
    showUpdateModal(model) {
      const params = {
        requestObjectKey: this.requestObjectKey,
        objectKey: model.objectKey,
      };
      this.loading = true;
      this.getDebtorEmployee(params)
        .then((res) => {
          this.formModel = res.data;
          this.isEditMode = true;
          this.$refs.addModal.show();
        })
        .finally(() => {
          this.loading = false;
        });
    },
    resetForm() {
      this.$refs.addForm.$validator.reset();
    },
    onCloseModal() {
      for (const key in this.formModel)
        if (Object.hasOwnProperty.call(this.formModel, key))
          this.$set(this.formModel, key, undefined);
      this.resetForm();
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .info-item-box .info-item-details:nth-child(1) {
  background: var(--app-light-secondary-color) 0% 0% no-repeat padding-box;
}

.totalCount {
  padding: 6px;
  margin-right: 2px;
  margin-left: 13px;
  background-color: black;
  font-size: 13px;
  color: white;
}

div p {
  font-size: 15px;
}
</style>
